import { render, staticRenderFns } from "./MyDesign.vue?vue&type=template&id=64f6021a&scoped=true"
import script from "./MyDesign.vue?vue&type=script&lang=js"
export * from "./MyDesign.vue?vue&type=script&lang=js"
import style0 from "./MyDesign.vue?vue&type=style&index=0&id=64f6021a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f6021a",
  null
  
)

export default component.exports